module.exports = __webpack_public_path__ + "static/media/info.4b99e4e3.svg";